import { render, staticRenderFns } from "./BannerLender.vue?vue&type=template&id=2e2b6c20&scoped=true&"
import script from "./BannerLender.vue?vue&type=script&lang=js&"
export * from "./BannerLender.vue?vue&type=script&lang=js&"
import style0 from "./BannerLender.vue?vue&type=style&index=0&id=2e2b6c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2b6c20",
  null
  
)

export default component.exports